import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { amberChipClass } from '../contactDisplay'
import type { RhythmStatus } from '../query/types'

const WORDS = { op_schema: 'Op schema', binnenkort: 'Binnenkort' } as const

/** "Contactritme" (design §3.4, §5.2): words, a missed rhythm as a chip ("Gemist", E2's announced state). */
export function RhythmCell({ status }: { status: RhythmStatus }) {
  if (status === 'geen') return <span className="text-muted-foreground">—</span>
  if (status === 'gemist') {
    return (
      <Badge variant="outline" className="border-destructive/40 text-destructive">
        Gemist
      </Badge>
    )
  }
  return <span className={cn(status === 'binnenkort' ? cn('rounded px-1', amberChipClass) : 'text-muted-foreground')}>{WORDS[status]}</span>
}
